import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class TKTest extends TKCustomElementFactory {
    constructor() {
        super();
    }

    connectedCallback() {
        this.registerButtonClick();
    }

    // #region button click handling
    registerButtonClick() {
        const buttonCLickHandler = this.onButtonClick.bind(this);

        this.pushListener({
            event: 'click',
            element: this,
            action: buttonCLickHandler,
        });
    }

    onButtonClick() {
        console.log('test');
    }
    // #endregion button click handling
}
